import MuiPopover from '@mui/material/Popover';
import Image from 'next/image';
import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Text } from '@nerdwallet/currency/components/Text';

type PopoverProps = React.ComponentProps<typeof MuiPopover>;

export interface Props {
  anchorEl: PopoverProps['anchorEl'];
  onClose: PopoverProps['onClose'];
  open: PopoverProps['open'];
  qrCode: any;
}

const AppDownloadPopover: React.FC<Props> = ({
  anchorEl,
  onClose,
  open,
  qrCode,
}) => (
  <MuiPopover
    anchorEl={anchorEl}
    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
    disableScrollLock
    onClose={onClose}
    open={open}
    slotProps={{ paper: { style: { marginTop: '0.5rem' } } }}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      gridGap="2"
      padding="2"
      width="100"
    >
      <Text align="center" bold>
        Scan QR code to download
      </Text>
      <Image alt="" src={qrCode} height={120} width={120} />
    </Box>
  </MuiPopover>
);

export default AppDownloadPopover;
